import React, { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  getSelectedCase,
  getSingleParty,
  setToggle,
  setToggle_2,
  toggleState,
  toggleState_2,
} from "../../../states/slices/partyInfo.slice";
import { TableComponent } from "../../../components/table/Table";
import { PARTY_COLUMNS_view } from "../../../components/table/columns";
import Typography from "../../../components/Typography";
import { CHEVRON_LEFT, FLAG, MINUS, PDF_ICON, QUESTION } from "../../../assets";
import {
  fetchPageOptions,
  formatCurrency,
  getFlagStyle,
  getJSONheader,
} from "../../../utils";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/button";
import Api from "../../../config";
import { useGetPaymentsQuery } from "../../../services/apis/cases";
import { toast } from "react-hot-toast";
import PartyInformation from "../../../components/modals/Partinformation";
import FillingFee from "../../../components/modals/FillingFee";
import { PDFDocument, rgb, StandardFonts, degrees } from "pdf-lib";
import { selectUser } from "../../../states/slices/authReducer";
import Modal from "../../../components/UI/modal";

import Preloader from "../../../components/preloader";

import moment from "moment";
import { Loader2 } from "lucide-react";

function ProcessPayment() {
  const [suitNumberBtnClicked, setSuitNumberBtnClicked] = useState<
    "creating" | "almostDone" | "success" | "error" | null
  >(null);

  const getCase = useAppSelector(getSelectedCase);
  // const user = useAppSelector(selectUser);
  const [docId, setDocId] = useState<any>(null);
  const [loadingReceipt, setLoadingReceipt] = useState(false);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(3);
  const navigate = useNavigate();
  const [remark, setRemark] = useState<any>("");
  const [paymentID, setPaymentID] = useState<any>();
  const [remarkRequire, setRemarkRequire] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [rjloading, setRjLoading] = useState<boolean>(false);
  const toggleStatus = useAppSelector(toggleState);
  const toggleStatus_2 = useAppSelector(toggleState_2);
  const singlePartyInfo = useAppSelector(getSingleParty);
  const dispatch = useAppDispatch();
  const [products, setProducts] = useState<any[]>([getCase?.case_documents]);
  const [totalPrice, setTotalPrice] = useState<number>();
  const [selectedCaseDocumentId, setSelectedCaseDocumentId] = useState<
    string | null
  >(null);
  const [selectedItems, setSelectedItems] = useState<any[]>([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [open, setOpen] = useState(false);
  const [blobUrl, setBlobUrl] = useState<any>(null);
  const [serviceBailiff, setServiceBailiff] = useState<boolean>(false);
  // const [suitnumber, setSuitNumber] = useState(getCase?.suit_number);

  const [selectedDoc, setSelectedDoc] = useState<any>(null);
  const [viewOnly, setViewOnly] = useState(false);
  const [selectedPdfId, setSelectedPdfId] = useState(null);
  const [openReceiptViewer, setOpenReceiptViewer] = useState(false);
  const [passReceiptUrl, setPassReceiptUrl] = useState<string>("");
  const [targetPageIndex, setTargetPageIndex] = useState(0); // Default to the first page
  const [pageOptions, setPageOptions] = useState<number[]>([]); // Array of available pages
  const [showPageSelector, setShowPageSelector] = useState(false);
  const [activeCaseInView, setActiveCaseInView] = useState<any>(null);
  const [promptModal, setPromptModal] = useState(false);
  const [showInputs, setShowInputs] = useState(false);

  const pageOptionsRef = useRef<HTMLDivElement>(null);
  const [preloaderState, setPreloaderState] = useState<
    "creating" | "almostDone" | "success" | "error" | null
  >(null);
  const [pageLoaderState, setPageLoaderState] = useState<
    "creating" | "almostDone" | "success" | "error" | null
  >(null);
  const [pageLoader, setPageLoader] = useState<
    "creating" | "almostDone" | "success" | "error" | null
  >(null);
  const [isStamped, setIsStamped] = useState(false);
  const [showOptionsSelector, setShowOptionsSelector] = useState(false);
  const [positionValue, setPositionValue] = useState("");

  const handleSelectChange = (event: any) => {
    setSelectedOption(event.target.value);
  };

  const handleMarkAll = () => {
    const allSelectedItems =
      selectedItems.length === getCase?.case_documents.length;
    if (allSelectedItems) {
      setSelectedItems([]);
    } else {
      setSelectedItems(
        getCase?.case_documents?.map((item: any) => ({
          case_document_id: item.id,
          service_by_bailiff: serviceBailiff,
        })),
      );
    }
  };
  const handleChangeMark = (event: React.ChangeEvent<HTMLInputElement>) => {
    const itemId = event.target.id;
    const isChecked = event.target.checked;

    const selectedItem = getCase?.case_documents.find(
      (item: any) => item.id === itemId,
    );

    if (selectedItem) {
      if (isChecked) {
        setSelectedItems((prevSelectedItems) => [
          ...prevSelectedItems,
          {
            case_document_id: selectedItem.id,
            service_by_bailiff: serviceBailiff,
          },
        ]);
      } else {
        setSelectedItems((prevSelectedItems) =>
          prevSelectedItems.filter(
            (item) => item.case_document_id !== selectedItem.id,
          ),
        );
      }
    }
  };
  useEffect(() => {
    fetchDataFromBackend();
  }, [getCase?.case_documents]);

  const fetchDataFromBackend = () => {
    // Simulated data from the backend

    const updatedProducts = getCase?.case_documents.map((data: any) => ({
      case_document_id: data.id,
      file_path: data.file_path,
      title: data.title,
      price: 0,
    }));
    // Initialize price as empty string

    setProducts(updatedProducts);
  };

  const { paymentData, isLoadingCases, refetch } = useGetPaymentsQuery(null, {
    selectFromResult: ({ data, isLoading, isError }: any) => ({
      paymentData: data?.data,
      isLoadingCases: isLoading,
    }),
  });

  useEffect(() => {
    handlePaymentData(paymentData);
  }, [paymentData]);

  useEffect(() => {
    refetch();
  }, [page]);

  const handlePaymentData = (paymentData: any[]) => {
    paymentData?.map((item: any) => {
      if (item?.service?.id === getCase?.id) {
        // console.log(item, 'ddd');

        setPaymentID(item);
        return item;
      }
    });
  };

  const addSuitNumber = async (pdf: string, item: any, suitNumber: string) => {
    try {
      const existingPdfBytes = await fetch(pdf).then((res) =>
        res.arrayBuffer(),
      );

      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pages = pdfDoc.getPages();

      pages.forEach((page) => {
        page.drawText(`Suit No: ${suitNumber}`, {
          x: 50,
          y: page.getHeight() - 50,
          size: 12,
          color: rgb(0, 0, 0),
        });
      });

      const pdfBytes = await pdfDoc.save();
      // @ts-ignore
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      const file = new File([blob], "suit-number-added.pdf", {
        type: "application/pdf",
      });

      await handleUpdateDoc(file, item);

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error adding suit number to PDF:", error);
      toast.error("Failed to add suit number to the document.", {
        duration: 3000,
      });
    }
  };

  const handleAdvisePayment = async () => {
    setLoading(true);

    Api.post(
      `/registra2/case-folders/${getCase?.id}/assignment-ready`,
      {
        user_role: selectedOption,
        case_documents: selectedItems,
      },
      getJSONheader(),
    )
      .then((res) => {
        toast.success(`${res?.data.message}`, {
          duration: 3000,
        });
        setLoading(false);
        navigate("/registrar-2/case-folders");
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error?.response?.data?.message, {
          duration: 3000,
        });
      });
  };
  const handleSendCourt = async () => {
    setLoading(true);

    Api.post(
      `/registra2/case-folders/${getCase?.id}/send-to-court`,
      {
        case_documents: selectedItems,
      },
      getJSONheader(),
    )
      .then((res) => {
        toast.success(`${res?.data.message}`, {
          duration: 3000,
        });
        setLoading(false);
        navigate("/registrar-2/case-folders");
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error?.response?.data?.message, {
          duration: 3000,
        });
      });
  };
  const handleApproveJoinRequest = async () => {
    setLoading(true);

    Api.patch(
      `/registra2/case-folders/${getCase?.id}/approve-join-request`,

      getJSONheader(),
    )
      .then((res) => {
        toast.success(`${res?.data.message}`, {
          duration: 3000,
        });
        navigate("/registrar-2/case-folders");
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        toast.error(error?.response?.data?.message, {
          duration: 3000,
        });
      });
  };

  const handleReject = () => {
    if (remark) {
      setRjLoading(true);
      Api.post(
        `/registra2/case-folders/${getCase?.id}/reject`,
        { remark: remark },
        getJSONheader(),
      )
        .then((res) => {
          // console.log(res);
          navigate("/registrar-2/case-folders");
          toast.success(`${res?.data.message}`, {
            duration: 3000,
          });
          setRjLoading(false);
        })
        .catch((error) => {
          setRjLoading(false);
          toast.error(error?.response?.data?.message, {
            duration: 3000,
          });
        });
    } else {
      setRemarkRequire("A remark is required");
    }
  };

  const handleUpdateDoc = async (file: File, item: any) => {
    try {
      const formData = new FormData();

      const fileBlob = new Blob([file], { type: "application/pdf" });
      formData.append("file_path", fileBlob, "file.pdf");

      const res: any = await Api.post(
        `registra2/case-documents/${item?.id || item?.case_document_id}/update`,
        formData,
      );
      console.log(res, "eeee");

      if (res) {
        setTimeout(() => setPreloaderState("almostDone"), 1000);

        setTimeout(() => {
          setPreloaderState("success");

          toast.success(res?.data?.message);
          setViewOnly(true);
          setBlobUrl(res?.data?.data?.file_path);
        }, 2000);
      }
    } catch (error: any) {
      setPreloaderState("error");
      toast.error(error?.response?.data?.message, {
        duration: 3000,
      });
    } finally {
      setTimeout(() => {
        setPreloaderState(null);
        setSuitNumberBtnClicked(null);
      }, 3000);
    }
  };

  const [receiptModalOpen, setReceiptModalOpen] = useState(false);
  const [selectedReceiptData, setSelectedReceiptData] = useState<any>(null);

  const fetchReceipt = async (docId: string) => {
    setLoadingReceipt(true);
    setDocId(docId);
    try {
      const response = await Api.get(
        `/case-documents/${docId}/payment`,
        getJSONheader(),
      );
      if (response?.data?.data) {
        setSelectedReceiptData(response.data.data);
        setReceiptModalOpen(true);
      }
    } catch (error: any) {
      console.error("Error fetching receipt:", error);
      toast.error(error?.response?.data?.message || "Failed to fetch receipt");
    } finally {
      setLoadingReceipt(false);
    }
  };

  const ViewReceiptModal = () => {
    const payment = selectedReceiptData?.payment;
    const document = selectedReceiptData?.case_document;

    return (
      <Modal
        open={receiptModalOpen}
        close={() => {
          setReceiptModalOpen(false);
          setSelectedReceiptData(null);
        }}
        maxWidth="md"
      >
        <div className="p-6">
          <Typography textStyle="text-xl font-bold mb-4">
            Payment Receipt
          </Typography>

          {payment && (
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div>
                <p className="text-gray-600 text-sm">Total Amount Paid</p>
                <p className="font-semibold text-lg">
                  {formatCurrency({ iso: "en-ng", slug: "NGN" }).format(
                    payment.amount,
                  )}
                </p>
              </div>
              <div>
                <p className="text-gray-600 text-sm">Payment Method</p>
                <p className="font-medium capitalize">{payment.method}</p>
              </div>
              <div>
                <p className="text-gray-600 text-sm">Reference</p>
                <p className="font-medium">{payment.reference}</p>
              </div>
              <div>
                <p className="text-gray-600 text-sm">Status</p>
                <span
                  className={`px-2 py-1 rounded text-xs font-medium ${
                    payment.status === "success"
                      ? "bg-green-100 text-green-800"
                      : "bg-yellow-100 text-yellow-800"
                  }`}
                >
                  {payment.status}
                </span>
              </div>
              <div>
                <p className="text-gray-600 text-sm">Transaction Date</p>
                <p className="font-medium">
                  {payment.created_at
                    ? moment(payment.created_at).format("MMM DD, YYYY HH:mm")
                    : "N/A"}
                </p>
              </div>
            </div>
          )}

          {document && (
            <div className="mb-6 border-t pt-4">
              <Typography textStyle="text-lg font-semibold mb-2">
                Document Details
              </Typography>
              <div className="flex justify-between items-center bg-gray-50 p-3 rounded">
                <div>
                  <p className="font-medium">{document.title}</p>
                  <p className="text-xs text-gray-500">
                    Price:{" "}
                    {formatCurrency({ iso: "en-ng", slug: "NGN" }).format(
                      document.price,
                    )}
                  </p>
                </div>
              </div>
            </div>
          )}

          {payment?.file_path && (
            <div className="border-t pt-4">
              <Typography textStyle="text-lg font-semibold mb-2">
                Receipt Image
              </Typography>
              <div className="flex justify-center bg-gray-100 p-4 rounded">
                <img
                  src={payment.file_path}
                  alt="Payment Receipt"
                  className="max-h-[400px] object-contain"
                />
              </div>
            </div>
          )}
        </div>
      </Modal>
    );
  };

  const HandleViewOnlyDoc = () => {
    return (
      <Modal
        open={viewOnly}
        close={() => {
          setViewOnly(false);
          setBlobUrl(null);
        }}
        maxWidth="lg"
      >
        <iframe
          title="PDF Viewer"
          src={`${blobUrl}#page=${targetPageIndex + 1}`}
          className="w-full"
          height={900}
        />
      </Modal>
    );
  };
  const HandleViewReceipt = () => {
    return (
      <Modal
        open={openReceiptViewer}
        close={() => {
          setOpenReceiptViewer(false);
          setPassReceiptUrl("");
        }}
        maxWidth="sm"
      >
        <div className="flex items-center justify-center pb-10">
          <img
            src={passReceiptUrl}
            className="w-[400px] h-[400px] object-cover"
            alt=""
          />
        </div>
      </Modal>
    );
  };

  const handleAppendClick = async (file_path: string, doc: any) => {
    setSelectedDoc(doc);
    setPageLoaderState("creating");
    try {
      const options = await fetchPageOptions(file_path); // Pass the PDF URL
      if (options) {
        setTimeout(() => {
          setPageLoaderState("almostDone");
        }, 1000);
        setTimeout(() => {
          toast.success("Fetched pdf pages successfully");
          setPageOptions(options);
          setShowPageSelector(true);
        }, 2000);
      }
    } catch (error) {
      console.error("Error fetching pages:", error);
    } finally {
      setTimeout(() => {
        setPageLoaderState(null);
      }, 2000);
    }
  };

  const [paymentReceipt, setPaymentReceipt] = useState([]);
  const getPaymentReceipt = async () => {
    try {
      const response = await Api.get(
        `/registra2/case-folders/${getCase?.id}/proof-of-payment`,
        getJSONheader(),
      );
      if (response) {
        setPaymentReceipt(response?.data?.data);
      }
    } catch (error: any) {
      console.log(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    getPaymentReceipt();
  }, [getCase?.id]);

  const handlePagePositionSelect = (position: string) => {
    setPositionValue(position);

    setShowOptionsSelector(false);
  };

  // function to trigger the append of stamp to document
  const handleAddStampToDocument = async () => {
    if (!selectedCaseDocumentId) {
      toast.error("No selected case document");
      return;
    }
    setPreloaderState("creating");
    setPositionValue("");
    setPromptModal(false);
    setOpen(false);

    const payload = {
      page: targetPageIndex + 1,
      position: positionValue,
    };

    try {
      const response: any = await Api.post(
        `/registra2/case-documents/${selectedCaseDocumentId}/stamp`,
        payload,
      );

      if (response) {
        setTimeout(() => setPreloaderState("almostDone"), 1000);

        setTimeout(() => {
          setPreloaderState("success");

          toast.success(response?.data?.message);
          setViewOnly(true);
          setBlobUrl(response?.data?.data?.file_path);
          setIsStamped(true);
        }, 2000);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
      setPreloaderState("error");
    } finally {
      setTimeout(() => {
        setPreloaderState(null);
      }, 2000);
    }
  };

  const showCaseFolder = async () => {
    setPageLoader("creating");
    try {
      const response = await Api.get(
        `/registra2/case-folders/${getCase?.id}`,
        getJSONheader(),
      );
      if (response) {
        setActiveCaseInView(response.data.data);
      }
    } catch (error: any) {
      console.log(error?.response?.data?.message);
    } finally {
      setPageLoader(null);
    }
  };

  useEffect(() => {
    showCaseFolder();
  }, [getCase?.id]);

  useEffect(() => {
    if (activeCaseInView?.suit_number) {
      setSelectedItems(
        activeCaseInView?.case_documents?.map((item: any) => ({
          case_document_id: item.id,
          service_by_bailiff: serviceBailiff,
        })),
      );
    }
  }, [activeCaseInView]);

  return (
    <>
      <div className="bg-[#F8F8F9E5]/90  w-full py-2 px-8">
        <Typography textStyle="text-base">{`My Files  / ${activeCaseInView?.title}`}</Typography>
      </div>

      <a
        type="button"
        className="text-sm my-4 px-4 lg:px-8 flex justify-end items-center w-full cursor-pointer"
        onClick={() => dispatch(setToggle_2(true))}
      >
        <sup className="animate-ping h-2 w-2 rounded-full bg-brand_blue/70"></sup>
        <img src={QUESTION} className="h-4" />{" "}
        <span className="mx-1">{` Information on `}</span>
        <span className="text-brand_blue font-bold">{` filing fees`}</span>
      </a>

      <div className="pt-4 px-4 lg:px-8 mb-4">
        <Typography textStyle="text-base font-medium mb-2">
          Party Information
        </Typography>
        <div className="my-2">
          {activeCaseInView?.parties?.length > 0 ? (
            <TableComponent
              className="rounded-none rounded-t-0"
              DATA={getCase?.parties}
              COLUMNS={PARTY_COLUMNS_view}
              TITLE=""
              isExport={null}
              isPaginated={null}
              isSearch={null}
              size={size}
              setSize={setSize}
              setPageIndex={(value: number) => page + 1}
            />
          ) : (
            <Typography variant="label" textStyle="font-medium text-center">
              No Party Information
            </Typography>
          )}
        </div>
        <div className="pt-8">
          <div className="flex items-center justify-between">
            <Typography textStyle="text-base font-medium ">
              Uploaded Documents
            </Typography>
            {!activeCaseInView?.suit_number && (
              <div className="gap-5 flex items-center">
                {!showInputs && (
                  <button
                    onClick={() => setShowInputs(true)}
                    className="text-sm font-medium px-4 py-2 rounded-md bg-[#1D1B73] text-white hover:bg-[#151257] transition"
                  >
                    Mark for Service
                  </button>
                )}
                {showInputs && (
                  <>
                    <button
                      onClick={handleMarkAll}
                      className="hover:opacity-70 shadow-custom text-white text-xs rounded-md bg-brand_indigo h-9 w-full px-5"
                    >
                      {selectedItems.length ===
                      activeCaseInView?.case_documents.length
                        ? "Unmark all"
                        : "Mark All"}
                    </button>
                    <button
                      onClick={() => setShowInputs(false)}
                      className="text-sm font-medium px-4 py-2 rounded-md border border-[#D1D5DB] text-[#374151] hover:bg-[#F3F4F6] transition"
                    >
                      Cancel
                    </button>
                  </>
                )}
              </div>
            )}
          </div>
          <div className="my-2 lg:flex justify-between items-center flex-wrap ">
            {activeCaseInView?.case_documents?.length > 0 ? (
              activeCaseInView?.case_documents.map(
                (item: any, index: number) => (
                  // <div className="w-full lg:w-[48%]">
                  //   <div
                  //     key={index}
                  //     className="flex justify-between items-center mb-3 border border-gray-200 w-full  p-3  rounded-lg"
                  //   >
                  //     <div className="flex justify-start items-center ">
                  //       <img src={PDF} className="h-6 w-6" />

                  //       <div className="ml-4">
                  //         <p className=" text-gray-400 text-xs ">
                  //           Document Title
                  //         </p>
                  //         <p className=" text-black font-bold text-sm mt-1">
                  //           {item?.title}
                  //         </p>
                  //       </div>
                  //     </div>
                  //   </div>
                  //   <div className="mb-4">
                  //     <button
                  //       type="button"
                  //       onClick={() => {
                  //         setBlobUrl(item?.file_path);
                  //         console.log(item?.file_path, "file path");

                  //         setViewOnly(true);
                  //         setSelectedPdfId(item?.id);
                  //       }}
                  //       className="px-2 py-1 bg-brand_indigo cursor-pointer text-[#fff] text-xs  w-28  rounded-md"
                  //     >
                  //       View only
                  //     </button>
                  //     <button
                  //       type="button"
                  //       onClick={() => {
                  //         handleAppendClick(item?.file_path, item);
                  //         setSelectedCaseDocumentId(item?.id);
                  //       }}
                  //       className=" px-2 py-1 bg-brand_indigo text-[#fff] text-xs  w-fit ml-4 rounded-md"
                  //     >
                  //       Append Stamp
                  //     </button>
                  //     {getCase?.suit_number && (
                  //       <button
                  //         // onClick={() => addStamp(item?.file_path, item)}
                  //         onClick={() => {
                  //           setSuitNumberBtnClicked("creating");
                  //           addSuitNumber(
                  //             item?.file_path,
                  //             item,
                  //             getCase?.suit_number
                  //           );
                  //         }}
                  //         className=" px-2 py-1 bg-brand_indigo text-[#fff] text-xs  w-fit ml-4 rounded-md"
                  //       >
                  //         Append Suit number
                  //       </button>
                  //     )}
                  //   </div>
                  //   {/* <span>add suit number: {getCase?.suit_number}</span> */}
                  // </div>

                  <div className="w-full max-h-[400px] overflow-y-auto py-2">
                    <div className="border-[1.1px] rounded-lg px-5 py-3 grid grid-cols-[auto_1fr_80px_64px_128px_128px_128px] items-center gap-x-4 border-[#E9EFF4] w-full">
                      {/* Flag Label */}
                      <div className="flex items-center gap-x-3">
                        {showInputs && (
                          <input
                            type="checkbox"
                            name={item?.id}
                            id={item?.id}
                            checked={selectedItems.some(
                              (selected) =>
                                selected.case_document_id === item.id,
                            )}
                            className="peer"
                            onChange={handleChangeMark}
                          />
                        )}
                        <span
                          className={`text-[10px] font-semibold px-2 py-1 rounded-full ${getFlagStyle(
                            item?.party_title,
                          )}`}
                        >
                          {item?.party_title.charAt(0).toUpperCase() +
                            item?.party_title.slice(1).toLowerCase()}
                        </span>
                      </div>

                      {/* File Info */}
                      <div className="flex items-center gap-x-4">
                        <img src={PDF_ICON} className="w-6 h-6" alt="PDF" />
                        <div className="flex flex-col">
                          <span className="text-[#292929] text-sm font-medium">
                            {item?.title}
                          </span>
                          <span className="text-[#292929] text-xs">
                            {moment(item?.created_at).format("MM/DD/YYYY")}
                          </span>
                        </div>
                      </div>

                      {/* Price */}
                      <div className="text-sm text-[#3A3A49] flex items-center justify-center h-[36px] rounded-lg bg-[#FAFAFB] border-2 border-[#E9EFF4]">
                        {formatCurrency({ iso: "en-ng", slug: "NGN" }).format(
                          item?.price,
                        )}
                      </div>

                      {/* View Button */}
                      <button
                        onClick={() => {
                          setBlobUrl(item?.file_path);
                          console.log(item?.file_path, "file path");

                          setViewOnly(true);
                          setSelectedPdfId(item?.id);
                        }}
                        className="hover:opacity-70 shadow-custom text-white text-xs rounded-md bg-brand_indigo h-9 w-full"
                      >
                        View
                      </button>

                      {/* Append Stamp */}
                      <button
                        onClick={() => {
                          // handleAppendClick(item?.file_path, item);
                          // setSelectedCaseDocumentId(item?.id);
                          navigate("/pdf-editor", { state: item });
                        }}
                        className="hover:opacity-70 shadow-custom text-white text-xs rounded-md bg-[#27BBEB] h-9 w-full"
                      >
                        Append Stamp
                      </button>

                      <button
                        onClick={() =>
                          fetchReceipt(item?.id || item?.case_document_id)
                        }
                        className="hover:opacity-70 shadow-custom text-white text-xs rounded-md bg-green-600 h-9 flex items-center justify-center w-full"
                      >
                        {loadingReceipt &&
                        docId === (item?.id || item?.case_document_id) ? (
                          <Loader2 className="w-5 h-5  animate-spin" />
                        ) : (
                          "View Receipt"
                        )}
                      </button>

                      {/* Append Suit Number */}
                      {/* <button
                      onClick={() => {
                        if (!getCase?.suit_number) {
                          toast.error(
                            "Suit number is not available for this case"
                          );
                          return;
                        } else {
                          setSuitNumberBtnClicked("creating");
                          addSuitNumber(
                            item?.file_path,
                            item,
                            getCase?.suit_number
                          );
                        }
                      }}
                      className="hover:opacity-70 shadow-custom text-white text-xs rounded-md bg-[#27BBEB] h-9 w-full"
                    >
                      Append Suit Number
                    </button> */}
                    </div>
                  </div>
                ),
              )
            ) : (
              <Typography variant="label" textStyle="font-medium text-center">
                No Uploaded Documents
              </Typography>
            )}
          </div>
        </div>
        {/* <div className="pt-8">
          <Typography textStyle="text-base font-medium ">
            Payment Receipt
          </Typography>
          <div className="my-2 lg:flex justify-between items-center flex-wrap ">
            {paymentReceipt?.length > 0 ? (
              paymentReceipt?.map((item: any, index: number) => (
                <div className="w-full lg:w-[48%]">
                  <div
                    key={index}
                    className="flex justify-between items-center mb-3 border border-gray-200 w-full p-3 rounded-lg cursor-pointer hover:shadow-md transition"
                    onClick={() => {
                      // logic to view receipt image
                    }}
                  >
                    <div className="flex items-center">
                      <img
                        src={item?.file_path || "/placeholder-receipt.jpg"}
                        alt="Receipt Preview"
                        className="h-12 w-12 rounded-md object-cover border"
                      />
                      <div className="ml-4">
                        <p className="text-gray-400 text-xs">Receipt</p>
                        <p className="text-black font-bold text-sm mt-1">
                          {item?.title || "Payment Receipt"}
                        </p>
                        <button
                          onClick={() => {
                            setOpenReceiptViewer(true);
                            setPassReceiptUrl(item?.file_path);
                          }}
                          className="text-blue-500 text-xs mt-1"
                        >
                          Click to view receipt
                        </button>
                      </div>
                    </div>
                  </div>

                </div>
              ))
            ) : (
              <Typography variant="label" textStyle="font-medium text-center">
                No payment made for the case folder
              </Typography>
            )}
          </div>
        </div> */}
        {/* <div className="pt-8 mb-4">
          <Typography textStyle="text-base font-medium mb-2">
            Mark For Service
          </Typography> 

           <div className="my-2 lg:flex justify-between items-center flex-wrap">
            {getCase?.case_documents.map((item: any) => (
              <div className="relative flex justify-start w-full  md:w-[48%] lg:w-[28%]">
                <label
                  htmlFor={item?.id}
                  className="flex  w-full px-4 py-2 border border-gray-300 justify-between items-center rounded-xl bg-white bg-opacity-90 backdrop-blur-2xl hover:bg-opacity-75 cursor-pointer transition"
                >
                  <div className="flex justify-start items-center">
                    <input
                      type="checkbox"
                      name={item?.id}
                      id={item?.id}
                      className="peer"
                      onChange={handleChangeMark}
                    />
                    <>
                      <a href={item?.file_path} target="_blank">
                        <img src={PDF} className="ml-1 h-6 w-6" />
                      </a>
                    </>

                    <Typography variant="label" textStyle="ml-4">
                      {item.title?.length > 7
                        ? `${item.title.slice(0, 7)}...`
                        : item.title}
                    </Typography>
                  </div>

                  <>
                    <span className="text-gray-400 text-xs font-medium ml-4">
                      {`${formatCurrency({
                        iso: "en-ng",
                        slug: "NGN",
                      }).format(item?.price)}`}
                    </span>
                    {item?.price !== 0 && (
                      <p className="text-[#22C55E] text-sm font-semibold text-center">
                        Paid
                      </p>
                    )}
                  </>
                </label>
              </div>
            ))}
          </div>

           {getCase?.suit_number && (
            <div className="flex flex-col items-start mt-4">
              <label htmlFor="suitNumber">Add Suit Number to document</label>
              <div className="flex items-center gap-2 border px-2 py-2 rounded-lg">
                <input
                  type="checkbox"
                  id="suitNumber"
                  // value={getCase?.suit_number}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setSuitNumber(getCase?.suit_number)
                  }
                  className="border px-2 py-1"
                />
                <span>Suit number: {getCase?.suit_number}</span>
              </div>
            </div>
          )} 
        </div> */}
        <div className={` justify-between lg:flex  items-start mt-6`}>
          {!activeCaseInView?.suit_number && (
            <div className="w-1/3">
              <Typography textStyle="text-base font-medium mb-2">
                Submit to User
              </Typography>

              <div className="relative ">
                <select
                  value={selectedOption}
                  onChange={handleSelectChange}
                  className="block appearance-none w-full bg-white border border-gray-300 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                >
                  <option value="">Select a Designation</option>
                  <option value="PRESIDING JUDGE">Presiding Judge</option>
                  <option value="PRESIDING MAGISTRATE">
                    Presiding Magistrate
                  </option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <svg
                    className="fill-current h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.95 7.95a.5.5 0 01.7-.7l5 5a.5.5 0 010 .7l-5 5a.5.5 0 01-.7-.7L17.29 13H2.5a.5.5 0 010-1h14.79l-4.04-4.04a.5.5 0 01-.03-.65z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </div>

              <div className="relative mt-6">
                <span className="">Service to Bailiff</span>
                <input
                  type="checkbox"
                  name={"bailiffCheck"}
                  id={"bailffCheck"}
                  checked={serviceBailiff}
                  className="peer ml-2"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setServiceBailiff(e.target.checked)
                  }
                />
              </div>
              {/* <Button
              isLoading={loading}
              icons={FLAG}
              iconClassName="h-[0.9rem] w-3"
              bgColor={"bg-[#27AE60]"}
              title={"Service to bailiff"}
              onClick={() => handleServiceToBailiff()}
              hoverColor={""}
              textColor={"text-white"}
              className={"py-3 w-full hidden md:flex mt-5"}
            /> */}
              {/* <button
              onClick={handleServiceToBailiff}
              className="bg-green-500 text-white rounded-lg p-3"
            >
              Service to bailiff
            </button> */}
            </div>
          )}

          <div className="w-full lg:w-[40%]">
            <Typography textStyle="text-base font-medium mb-2">
              <>
                Remarks <sup className="text-red-600 text-xs">*</sup>
              </>
            </Typography>

            <textarea
              name="remark"
              placeholder={"Kindly add remarks"}
              className="bg-[#13BAED0D] h-40 w-full resize-none flex justify-start p-4 text-sm"
              value={remark}
              onChange={(e) => {
                setRemark(e.target.value);
                setRemarkRequire("");
              }}
            />
            <small className="text-red-600">{remarkRequire}</small>
          </div>
        </div>
        <div className="w-full md:flex justify-between items-end mt-10">
          <div className="w-full lg:w-[45%] flex justify-between items-center flex-wrap">
            <Button
              icons={CHEVRON_LEFT}
              iconClassName="h-[0.9rem] w-3"
              title="Back"
              bgColor={"bg-brand_indigo"}
              onClick={() => navigate("/registrar-2/case-folders")}
              hoverColor={""}
              textColor={"text-white"}
              className={"py-3 w-32 hidden md:flex"}
            />

            <Button
              isLoading={rjloading}
              icons={MINUS}
              iconClassName="h-[0.9rem] w-3"
              title="Reject  Folder"
              bgColor={"bg-red-600"}
              onClick={() => handleReject()}
              hoverColor={""}
              textColor={"text-white"}
              className={"py-3 w-40 lg:w-44"}
            />
            <div className="w-40 md:w-44 md:hidden">
              <Button
                isLoading={loading}
                icons={FLAG}
                iconClassName="h-[0.9rem] w-3"
                bgColor={"bg-[#27AE60]"}
                title={"Ready to Submit"}
                onClick={() => handleAdvisePayment()}
                hoverColor={""}
                textColor={"text-white"}
                className={"py-3 w-full"}
              />
            </div>
          </div>

          <div className="w-[30%] md:w-44 mx-auto lg:mx-0 mt-3 lg:mt-0">
            <Button
              icons={CHEVRON_LEFT}
              iconClassName="h-[0.9rem] w-3"
              title="Back"
              bgColor={"bg-brand_indigo"}
              onClick={() => navigate("/registrar-2/case-folders")}
              hoverColor={""}
              textColor={"text-white"}
              className={"py-3 w-32 md:hidden flex"}
            />
            {activeCaseInView?.case_status?.status === "JOIN REQUEST" ? (
              <Button
                isLoading={loading}
                // icons={FLAG}
                iconClassName="h-[0.9rem] w-3"
                bgColor={"bg-[#27AE60]"}
                title={"Approve Join Request"}
                onClick={() => handleApproveJoinRequest()}
                hoverColor={""}
                textColor={"text-white"}
                className={"py-3 w-full hidden md:flex"}
              />
            ) : activeCaseInView?.suit_number ? (
              <Button
                isLoading={loading}
                icons={FLAG}
                iconClassName="h-[0.9rem] w-3"
                bgColor={"bg-[#27AE60]"}
                title={"Send to Court"}
                onClick={() => handleSendCourt()}
                hoverColor={""}
                textColor={"text-white"}
                className={"py-3 w-full hidden md:flex"}
              />
            ) : (
              <Button
                isLoading={loading}
                icons={FLAG}
                iconClassName="h-[0.9rem] w-3"
                bgColor={"bg-[#27AE60]"}
                title={"Ready to Submit"}
                onClick={() => handleAdvisePayment()}
                hoverColor={""}
                textColor={"text-white"}
                className={"py-3 w-full hidden md:flex"}
              />
            )}
          </div>
        </div>
        {/* {HandleOpenDoc()} Conditionally render the modal */}
        {HandleViewOnlyDoc()} {HandleViewReceipt()}
        {/* Conditionally render the modal to view the doc without stamp */}
        <PartyInformation
          open={toggleStatus}
          close={() => dispatch(setToggle(false))}
          data={singlePartyInfo}
        />
        <FillingFee
          open={toggleStatus_2}
          close={() => dispatch(setToggle_2(false))}
        />
      </div>

      <Preloader
        preloaderState={
          preloaderState ||
          pageLoaderState ||
          suitNumberBtnClicked ||
          pageLoader
        }
        action={
          preloaderState === "creating"
            ? "Appending stamp"
            : pageLoaderState
              ? "Fetching pdf pages"
              : suitNumberBtnClicked
                ? "Appending suit number"
                : pageLoader === "creating"
                  ? "Loading case folder"
                  : ""
        }
      />
      <ViewReceiptModal />
    </>
  );
}

export default ProcessPayment;
